export namespace MoveHints {
  export namespace Plugin {
    export const Name = 'move-hints';
  }
}
